export function httpLoad(pUrl, pCallback, bearerToken = false) {
  const xhr = new XMLHttpRequest();
  const onError = () => pCallback(xhr, null);

  xhr.open('GET', pUrl);
  if (bearerToken) {
    xhr.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
  }

  xhr.onload = function () {
    if (xhr.status === 200) {
      try {
        pCallback(null, xhr.response);
      } catch (error) {
        pCallback(error, null);
      }
    }
    if (xhr.status >= 400) {
      onError();
    }
  };
  xhr.onerror = onError;
  xhr.send();
}
